<template>
  <div class="py-4 container-fluid">
    <GridRow>
      <GridCol :md="12">
        <MetaSection></MetaSection>
      </GridCol>
      <GridCol :md="12">
        <form>
          <div class="d-flex flex-row gap-2">
            <FormGroup>
              <!-- <select name="unitkerja" id="unitkerja" v-model="params.unitkerja_id" class="form-control">
                <option value="">Semua Unit Kerja</option>
                <option v-for="(item, index) in unitkerja" :key="index" :value="item.id">{{ item.name }}</option>
              </select> -->

              <model-list-select
                class="form-control"
                style="width: 350px;"
                v-model="params.unitkerja_id"
                :list="unitkerja"
                option-value="id"
                option-text="name"
                placeholder="Semua Unit Kerja"
              />
                <!-- @change="changeKpi()" -->
            </FormGroup>
            <FormGroup>
              <!-- <select name="posisi" id="posisi" v-model="params.jabatan_id" class="form-control">
                <option value="">Semua Jabatan</option>
                <option v-for="(item, index) in jabatan" :key="index" :value="item.id">{{ item.name }}</option>
              </select> -->
              <model-list-select
                class="form-control"
                v-model="params.jabatan_id"
                :list="jabatan.sort((a, b) => a.name.localeCompare(b.name))"
                option-value="id"
                option-text="name"
                placeholder="Semua Jabatan"
              />
            </FormGroup>
          </div>
        </form>
      </GridCol>

      <GridCol :md="12">
        <GridRow v-if="kpi.length > 0">
          <GridCol :md="6"
            v-for="(item, index) in kpi"
            :key="index"
            class="mb-4"
          >
            <RealisasiGabunganCard
              :kpi="item"
              :index_kpi="index"
            />
          </GridCol>
        </GridRow>

        <p v-else class="text-center p-6">Data tidak ditemukan.</p>
      </GridCol>

    </GridRow>
  </div>
</template>

<style scoped>
li::marker {
  display: none;
}

li:first-child::before {
  content: "\2022";
  font-weight: bold;
  display: inline-block;
  width: 1em;
  margin-left: -1em;
  color: #0385F3 !important;
}
</style>

<script>
// import PerformanceHistoryChart from "../examples/Charts/PerformanceHistoryChart.vue";
// import Cards from "../components/CardComponent.vue";
import RealisasiGabunganCard from "@/components/RealisasiGabunganCard.vue";
import GridRow from "@/components/grid/GridRow.vue";
import GridCol from "@/components/grid/GridCol.vue";
import MetaSection from "@/components/MetaSection.vue";
import FormGroup from '@/components/FormGroup.vue';
import { ModelListSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";

import JabatanApi from '@/repository/api/JabatanApi';
import UnitKerjaApi from '@/repository/api/UnitKerjaApi';
// import KpiApi from "@/repository/api/KpiApi";
import LaporanGabunganApi from '@/repository/api/LaporanGabunganApi';

export default {
  name: "dashboard-default",
  components: {
    RealisasiGabunganCard,
    GridRow,
    GridCol,
    MetaSection,
    FormGroup,
    ModelListSelect,
  },
  data() {
    return {
      kpi: [],
      unitkerja: [],
      jabatan: [],
      params: {
        unitkerja_id: "",
        jabatan_id: "",
        // page: 1,
      }
    };
  },
  watch: {
    // 'params': {
    //   handler: async function () {
    //     this.params.page = 1;
    //     this.params.jabatan_id = "";
    //     await this.getKpi();
    //   },
    //   deep: true,
    // },
    'params.unitkerja_id': {
      handler: async function () {
        this.jabatan = '';
        this.jabatan_id = '';
        await this.getJabatan();
        await this.getKpi();
      },
      deep: true,
    },
    'params.jabatan_id': {
      handler: async function () {
        await this.getKpi();
      },
      deep: true,
    },
  },
  methods: {
    async getUnitKerja() {
      this.$store.state.loading = true;

      await UnitKerjaApi.getbyparam({
        page: 'all',
      })
      .then((response) => {
        this.unitkerja = response.data;
      }).catch(() => {
        this.unitkerja = [];
      });
      this.$store.state.loading = false;
    },
    
    async getJabatan() {
      this.$store.state.loading = true;
      let params = {
        page: 'all',
      };

      if (this.params.unitkerja_id != "") {
        params = {
          unitkerja_id: this.params.unitkerja_id,
        }
        params.unitkerja_id = this.params.unitkerja_id;
      }
      await JabatanApi.getbyparam(params)
        .then((response) => {
          this.jabatan = response.data;
        }).catch(() => {
          this.jabatan = [];
        });

      this.$store.state.loading = false;
    },

    async getKpi() {
      this.$store.state.loading = true;
      await LaporanGabunganApi.getListKpi(this.params)
        .then((response) => {
          this.kpi = response?.data;
        }).catch(() => {
          this.kpi = [];
        });
      this.$store.state.loading = false;
    }
  },
  async mounted() {
    this.$store.state.loading = true;
    await this.getUnitKerja();
    // await this.getJabatan();
    await this.getKpi();
    this.$store.state.loading = false;
  },
};
</script>
